import { getWidgetAttributes } from '@sportal365/smp-widget-utils';
import WidgetAttributes from '../../../../../packages/constants/widgetAttributes';
import { STAKES } from '../../../../../packages/constants/widgetIds';

export const stakesAttributes = getWidgetAttributes(
  STAKES,
  // Required attributes:
  [WidgetAttributes.WIDGET_ID, WidgetAttributes.WIDGET_SPORT, WidgetAttributes.WIDGET_TYPE, WidgetAttributes.MATCH],
  // Optional attributes:
  [
    WidgetAttributes.AMOUNT,
    WidgetAttributes.ENTITY_LINKS,
    WidgetAttributes.FIXED,
    WidgetAttributes.LABELS,
    WidgetAttributes.ODDS_BETTING_ID,
    WidgetAttributes.ODDS_PRE_EVENT_ONLY,
    WidgetAttributes.REFRESH_TIME,
    WidgetAttributes.THEME,
    WidgetAttributes.CURRENCY_POSITION,
  ],
);
